export const formatLowerCase = str => {
  return (str || '').toLowerCase();
};
